export default {
  hotels: [],
  pagination: {},
  hotel: {}
}
